import React, { useState } from "react";
import { Layers } from "lucide-react";
import { PageHeader, Pill } from "@admin/components/Primitives";
import LevelApplicationsQueue from "@admin/components/approvals/LevelApplicationsQueue";
import { notifyApprovalsChanged } from "@admin/services/adminApi";

export default function AdminLevelApprovals() {
  const [count, setCount] = useState(null);
  return (
    <>
      <PageHeader
        testid="admin-level-approvals-header"
        title="Lawyer Level Approval"
        subtitle="Level requests from onboarding and the lawyer portal. Approve as requested, adjust with a reason, or reject. Approval activates the level immediately — every fee then follows the level table under Pricing & Offers."
        actions={count !== null && <span className="whitespace-nowrap"><Pill color={count ? "amber" : "blue"}>{count} pending</Pill></span>}
      />
      <section className="bg-white border border-slate-200 rounded-2xl p-5" data-testid="level-approvals-card">
        <p className="text-xs uppercase tracking-wider font-bold text-slate-400 mb-3 flex items-center gap-1.5">
          <Layers size={14} /> Requests awaiting review
        </p>
        <LevelApplicationsQueue onCountChange={(n) => { setCount(n); notifyApprovalsChanged(); }} />
      </section>
    </>
  );
}
